import { Answer } from '../../redux/Slices/InterviewSlice/types';
import api from '../api';

export const authApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllDriveCompanies: builder.query({
      query: payload => ({
        url: '/api/company/fetchall/drive/companies',
        method: 'GET'
      })
    }),
    getDriveTestsForCompany: builder.query({
      query: ({ companyId, totalTestCount }) => ({
        url: '/api/drive/test/assigned/drivetests',
        method: 'GET',
        params: { companyId, totalTestCount }
      })
    }),
    getDriveCompanyPattern: builder.query({
      query: ({ testAssignmentId, testSetId }) => ({
        url: '/api/drive/test/start/test',
        method: 'POST',
        params: { testAssignmentId, testSetId }
      })
    }),
    driveEndTest: builder.mutation({
      query: userTestId => ({
        url: '/api/drive/test/end/test',
        method: 'PUT',
        params: {
          userTestId
        }
      })
    }),
    driveSubmitTest: builder.mutation({
      query: ({ userTestId, body }: { userTestId: string; body: Answer }) => ({
        url: '/api/drive/test/submit/test',
        method: 'PUT',
        body,
        params: {
          userTestId
        }
      })
    }),
    getDriveInstructionsForTest: builder.query({
      query: () => ({
        url: '/api/drive/test/drive/test/instructions',
        method: 'GET'
      })
    }),
    discardDriveTest: builder.mutation({
      query: ({ userTestId, testSetId }) => ({
        url: 'api/drive/test/discard/test',
        method: 'PUT',
        params: { userTestId, testSetId }
      })
    })
  })
});

export const {
  useGetAllDriveCompaniesQuery,
  useLazyGetDriveTestsForCompanyQuery,
  useLazyGetDriveCompanyPatternQuery,
  useDriveEndTestMutation,
  useLazyGetDriveInstructionsForTestQuery,
  useDriveSubmitTestMutation,
  useDiscardDriveTestMutation
} = authApi;
